import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=6f3aa076&"
import script from "./PayDialog.vue?vue&type=script&lang=js&"
export * from "./PayDialog.vue?vue&type=script&lang=js&"
import style0 from "./PayDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports